var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"offer-info",attrs:{"to":{name: 'ViewOffer', params: {id: _vm.offer.id}}}},[_c('div',[_c('div',{staticClass:"offer-info__preview-image",style:(`background-image:url(${_vm.offer.first_image})`)})]),_c('div',[_vm._v(" "+_vm._s(_vm.offer.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }